import Wrapper from '../../assets/wrappers/JobInfo';

const CampaignInfo = ({ icon, text }) => {
  return (
    <Wrapper>
      <span className="job-icon">{icon}</span>
      <span className="job-text">{text}</span>
    </Wrapper>
  );
};

export default CampaignInfo;
